import type { IStorageService } from "@/services/interfaces/IStorageService";

const MOCK_DELAY_MS = 600;

function delay(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

function generateId(): string {
  return `mock-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
}

export class MockStorageService implements IStorageService {
  private store: Map<string, string> = new Map();

  async upload(file: File, _path: string): Promise<{ url: string; id: string }> {
    await delay(MOCK_DELAY_MS);

    const id = generateId();
    const url = URL.createObjectURL(file);
    this.store.set(id, url);

    return { url, id };
  }

  async getUrl(id: string): Promise<string> {
    await delay(300);

    const url = this.store.get(id);
    if (!url) {
      throw new Error(`File not found: ${id}`);
    }
    return url;
  }

  async delete(id: string): Promise<void> {
    await delay(500);

    const url = this.store.get(id);
    if (!url) {
      throw new Error(`File not found: ${id}`);
    }

    // Revoke the object URL to free memory
    URL.revokeObjectURL(url);
    this.store.delete(id);
  }
}
